import { ConciergeKnowledgeSchema } from "@redotech/redo-concierge-common/concierge-knowledge";
import * as z from "zod";

export const getConciergeKnowledge = {
  name: "getConciergeKnowledge" as const,
  input: z.object({ _id: z.string() }).strict(),
  output: ConciergeKnowledgeSchema,
};
